import { type FC, useEffect } from 'react'

import { useLocation } from 'react-router-dom'

export interface Props {}

export const ScrollToTop: FC<Props> = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
